import { type FC } from "react";
import { Tr } from "@root/shared/components/Table/legacy/Tr";
import { Th } from "@root/shared/components/Table/legacy/Th";
import { Td } from "@root/shared/components/Table/legacy/Td";
import * as styles from "./styles.css";

type Props = {
  header: string;
  children: React.ReactNode;
};

export const DetailTableRow: FC<Props> = ({ header, children }) => (
  <Tr className={styles.tr}>
    <Th className={styles.th}>{header}</Th>
    <Td>{children}</Td>
  </Tr>
);
